import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'IdOutput',
  props: {
    input: null,
    prefix: null,
    param: {
      default: 'id'
    },
    isSpaceDelimiter: {
      type: Boolean,
      default: true
    },
    empty: {
      default: 'Неизвестно'
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var id = computed(function () {
      var _props$input;
      return (_props$input = props.input) === null || _props$input === void 0 ? void 0 : _props$input[props.param];
    });
    var delimiter = computed(function () {
      return props.isSpaceDelimiter ? ' ' : '';
    });
    return {
      __sfc: true,
      props: props,
      id: id,
      delimiter: delimiter
    };
  }
});